import React, { memo } from "react"
const RedSolidButton = ({ text, onClick, ...rest }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="focus:outline-none text-white py-2.5 px-5 rounded-md bg-red-500 hover:bg-red-600 hover:shadow-lg text-base md:text-lg"
      {...rest}
    >
      {text}
    </button>
  )
}
export default memo(RedSolidButton)
